import axios from 'axios'
import BaseInterceptors from './interseptors/base-interseptors'

const baseDomain = process.env.VUE_APP_FILE_STORE
const baseURL = `${baseDomain}/api/v1`

const axiosInstance = axios.create({
    baseURL
})
BaseInterceptors.use(axiosInstance)

export default {
    login(data) {
        const resource = '/login'
        return axiosInstance.post(`${resource}`, data).then(resp => resp.data)
    },

    async uploadFile({login, password, file}) {
        let { userUuid, authToken } = await this.login({ login, password });
        let formData = new FormData();
        formData.append('file', file);
        formData.set('isPublic', true);
        
        let resp = await axiosInstance.post(`/users/${userUuid}/files`, formData, {
            headers: {
                'Authorization': authToken,
                'Content-Type': 'multipart/form-data',
            }            
        })

        return baseURL + '/files/' + resp.data.hash
    }
}